import types from '../actionTypes';

const INITIAL_STATE = {
    isFetchingAllList: false,
    errors: '',
    codelist: [],
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case types.CODELIST_FETCH_SUCCESS:
            return {
                ...state,
                isFetchingAllList: false,
                codelist: action.payload.codelists,
            };
        case types.CODELIST_FETCH_FAIL:
            return {
                ...state,
                isFetchingAllList: false,
                errors: action.payload.error,
            };
        case types.CODELIST_FETCH_REQUEST:
            return {
                ...state,
                isFetchingAllList: true,
            };
        default:
            return state;
    }
};
